





































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as util from "comunet-jobs-and-technician-repository-shared/util";
import { Job } from '@/models/jobDetail/job';
import JobLocation from '@/components/jobDetail/JobLocation.vue';
import JobContact from '@/components/jobDetail/JobContact.vue';
import JobServiceForm from '@/components/jobDetail/JobServiceForm.vue';
import JobStatusSummary from '@/components/jobDetail/JobStatusSummary.vue';
import JobTechnicians from '@/components/jobDetail/JobTechnicians.vue';
import JobTestSummary from '@/components/jobDetail/JobTestSummary.vue';
import TestFailedNotification from '@/components/jobNotifications/TestFailedNotification.vue';
import Nullable from '@/types/nullable';

@Component({
  components: {
    JobLocation,
    JobContact,
    JobServiceForm,
    JobStatusSummary,
    JobTechnicians,
    JobTestSummary,
    TestFailedNotification
  }
})
export default class JobDetails extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;
  private showSendTestFailedNotification: boolean = false;

  readableDate(dateString: string): string {
    return util.readableDate(dateString);
  }

  viewJobNotes(){
    this.$router.push({ name: 'viewjobnotes', params: { jobID: this.job.id } });
  }
}

